import { faFish, faLeaf, faPeople } from '@fortawesome/pro-regular-svg-icons';

import theme from '@style/theme.json';

const INDICATORS = {
  oneHealthIndex: {
    label: 'One Health',
    color: theme.color.primary.main,
    icon: '/img/icons/circles-overlap-3-regular-full.svg',
    backgroundColor: theme.color['info-light'],
    valueBackgroundColor: '#fff',
  },
  humanHealthIndex: {
    label: 'Human Health',
    color: theme.color.warning,
    icon: faPeople,
  },
  animalHealthIndex: {
    label: 'Animal Health',
    color: '#44B0E1',
    icon: faFish,
  },
  environmentalHealthIndex: {
    label: 'Environmental Health',
    color: theme.color.success,
    icon: faLeaf,
  },
};

const THRESHOLDS = [
  {
    min: 0,
    max: 20,
    class: 'Bad/Critical',
    interpretation: 'Severe impairment or high-risk OH condition',
    action: 'Urgent response/Intervention',
    color: 'brown',
  },
  {
    min: 20,
    max: 40,
    class: 'Poor',
    interpretation: 'Important degradation or health risk signal',
    action: 'Management action needed',
    color: theme.color.danger,
  },
  {
    min: 40,
    max: 60,
    class: 'Moderate/Watch',
    interpretation: 'System shows signs of stress; pressures or impacts emerging',
    action: 'Investigate drivers; activate early-warning response',
    color: theme.color.warning,
  },
  {
    min: 60,
    max: 80,
    class: 'Good',
    interpretation: 'Acceptable; pressures are present but controlled',
    action: 'Continue monitoring; targeted prevention',
    color: 'yellow',
  },
  {
    min: 80,
    max: 100,
    class: 'High/Very good',
    interpretation: 'Coastal OH condition close to the desired/reference state',
    action: 'Maintain monitoring; no immediate intervention',
    color: theme.color.success,
  },
];

const MONTH_NAMES = {
  1: 'January',
  2: 'February',
  3: 'March',
  4: 'April',
  5: 'May',
  6: 'June',
  7: 'July',
  8: 'August',
  9: 'September',
  10: 'October',
  11: 'November',
  12: 'December',
};

export {
  INDICATORS,
  THRESHOLDS,
  MONTH_NAMES,
};
